import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { WP_API_CURSOS_POS_GRADUACAO } from 'app/config';

export const URL_POSGRADUACAO = WP_API_CURSOS_POS_GRADUACAO + `/cursosposgraduacao/doutorado/`;
export const URL_POSGRADUACAO_FAMAZ = 'https://www.famaz.edu.br/famaz-wordpress/index.php//wp-json/wp/v2/cursosposgraduacao?per_page=20';

@Injectable()
export class DoutoradoService {

    constructor(private http: HttpClient, private stringUtils: StringUtilsService) { }

    async getCursosFamaz() {
      const data = await fetch(URL_POSGRADUACAO_FAMAZ)
      const result = await data.json()
      const resultsFiltereds = result.filter(pos => pos.tipo != "pos-med")


      return resultsFiltereds
    }

    async getCursosFamazPerId(codigo: number) {
      const cursos = await fetch(URL_POSGRADUACAO_FAMAZ)
      const data = await cursos.json()

      const result = data.filter(curso => curso.codigo === codigo)

      return result
    }

    async getImage(path: string): Promise<string> {
      const data = await fetch(path)
      const result = await data.json()

      const href = result.guid.rendered

      return href
    }

    listCursoDoutorado(){
        return this.http
        .get<any>(URL_POSGRADUACAO)
    }

    listCursoDoutoradoId(id){
        return this.http
        .get<any>(URL_POSGRADUACAO +`${id}`)
    }

    listCursoName(id: string): Promise<any>{
       return new Promise<any>((resolve, reject) => {
           this.http.get<any>(URL_POSGRADUACAO+`${id}`).subscribe(slugEdital => {
               let slug = this.stringUtils.textoParaSlug(slugEdital.cursosposgraduacao[0].nome);
               resolve(slug);
           },
           err => {
             reject(err);
           });
       });
    }
}
